import Breadcrumbs from '@components/Breadcrumbs';
import Grid from '@components/Grid';
import { Nav, NavItem, NavLink } from '@components/Nav';
import Container from '@components/UI/Container';
import Heading from '@components/UI/Typography/Heading';

import { Navigation } from "@layouts/NavigationV2";
import VersionBanner from '@screens/HelpCenter/Search/VersionBanner';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import Banner from '../../Banner';
import Search from '../../Search/SearchField';

const Show = ({ post, posts }) => {
    const { asPath, pathname, query } = useRouter();

    return (
        <>
            <Navigation
                staticTheme="neutral"
                actionTheme="neutral"
                background='bg-violet-900'
            />

            <div
                className='help-center'
            >
                {  <Search
                    isWide={ true }
                />  }

                <Breadcrumbs
                    wrap
                    pathname={ asPath.replace(/\?.+/, '') }
                />

                <Container>
                    <Grid
                        xs={ 1 }
                        lg={ 3 }
                        mix={ { 'help-center__layout': true } }
                    >
                        <main
                            className='help-center__content'
                        >
                            <VersionBanner className={"mb-5"} />
                            
                            <Heading
                                tag='h1'
                            >
                                { post?.title }
                            </Heading>

                            <div
                                className='help-center__post editor-post'
                                dangerouslySetInnerHTML={ { __html: post?.content } }
                            />
                        </main>

                        <nav
                            className='help-center__nav container'
                        >
                            <Nav>
                                <Heading
                                    tag='h4'
                                    color='neutral_900'
                                >
                                    Topics in this section
                                </Heading>

                                { posts?.map(post => (
                                    <NavItem
                                        key={ post.id }
                                    >
                                        <NavLink
                                            href={ pathname.replace('[category]', query.category).replace('[post]', post.slug) }
                                            active={ asPath.split('/').includes(post.slug) }
                                            mods={ { neutral: 700 } }
                                        >
                                            { post.title }
                                        </NavLink>
                                    </NavItem>
                                )) }
                            </Nav>
                        </nav>
                    </Grid>

                    <Banner />
                </Container>
            </div>
        </>
    );
};


Show.propTypes = {
    post: PropTypes.object,
    posts: PropTypes.array
};

export default Show;
